"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var form_management_service_1 = require("../../service/form-management.service");
var confirm_dialog_component_1 = require("../confirm-dialog/confirm-dialog.component");
var form_dialog_component_1 = require("../form/form-dialog.component");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Observable_1 = require("rxjs/Observable");
var FormsComponent = /** @class */ (function () {
    function FormsComponent(formManagementService, messageService, kbService, currentLanguageProvider, languageService, router, formDialog) {
        this.formManagementService = formManagementService;
        this.messageService = messageService;
        this.kbService = kbService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.languageService = languageService;
        this.router = router;
        this.formDialog = formDialog;
        this.initialized = false;
        this.isLoading = true;
        this.searchIsOpen = false;
        this.isHeaderHidden = false;
        this.destroy$ = new Subject_1.Subject();
        this.searchTerm = '';
        this.onItemsChange$ = new ReplaySubject_1.ReplaySubject(1);
        this.lastScroll = 0;
    }
    FormsComponent_1 = FormsComponent;
    FormsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.categoryForms$ = this.onItemsChange$.pipe(operators_1.mergeMap(function (_) { return _this.loadItems(); }), operators_1.publishReplay(1), operators_1.refCount());
        this.currentLanguageId$ = this.initializeLanguages().pipe(operators_1.publishReplay(1), operators_1.refCount());
        this.onItemsChange$.next(true);
    };
    FormsComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
    };
    FormsComponent.prototype.doSearch = function (term) {
        //search term must be debounced and not loaded each time from server
        this.searchTerm = term;
        this.onItemsChange$.next(true);
    };
    FormsComponent.prototype.searchClose = function (event) {
        this.searchIsOpen = !this.searchIsOpen;
        this.doSearch('');
        event.stopPropagation();
    };
    FormsComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
        this.onItemsChange$.complete();
    };
    FormsComponent.prototype.createForm = function (form) {
        var _this = this;
        if (form) {
            return this.formManagementService.create(form, FormsComponent_1.DE_PREFIX)
                .pipe(operators_1.map(function (newForm) {
                _this.onItemsChange$.next(true);
                _this.router.navigateByUrl(_this.router.url + '/form-builder/' + newForm.id);
                return true;
            }));
        }
        return Observable_1.Observable.of(false);
    };
    FormsComponent.prototype.deleteForm = function (form) {
        var _this = this;
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = 'auto';
        dialogConfig.width = '450px';
        var formDialogRef = this.formDialog.open(confirm_dialog_component_1.ConfirmDialogComponent, dialogConfig);
        formDialogRef.afterClosed()
            .pipe(operators_1.switchMap(function (isConfirmed) { return _this.deleteFormOnConfirm(isConfirmed, form); }), operators_1.take(1))
            .subscribe();
    };
    FormsComponent.prototype.getFormBuilderUrl = function (form) {
        return this.router.url + '/form-builder/' + form.id;
    };
    FormsComponent.prototype.openFormDialog = function (formType, headerKey, currentLanguageId) {
        var _this = this;
        var dialogConfig = this.configureDialog(formType, headerKey, currentLanguageId);
        var formDialogRef = this.formDialog.open(form_dialog_component_1.FormDialogComponent, dialogConfig);
        formDialogRef.afterClosed()
            .pipe(operators_1.switchMap(function (form) { return _this.createForm(form); }), operators_1.take(1)).subscribe();
    };
    FormsComponent.prototype.getCategories = function (categoryForms) {
        return Array.from(categoryForms.keys());
    };
    FormsComponent.prototype.showHideHeader = function (event) {
        this.isHeaderHidden = ((event.target.scrollTop > 68) && (event.target.scrollTop > this.lastScroll));
        this.lastScroll = event.target.scrollTop;
    };
    FormsComponent.prototype.deleteFormOnConfirm = function (isConfirmed, form) {
        var _this = this;
        if (isConfirmed) {
            return this.formManagementService.delete(form)
                .pipe(operators_1.map(function (_) {
                _this.onItemsChange$.next(true);
                return true;
            }));
        }
        return Observable_1.Observable.of(false);
    };
    FormsComponent.prototype.configureDialog = function (formType, headerKey, currentLanguageId) {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = 'auto';
        dialogConfig.width = '450px';
        dialogConfig.data = {
            currentLanguageId: currentLanguageId,
            formType: formType,
            headerKey: headerKey
        };
        return dialogConfig;
    };
    FormsComponent.prototype.loadItems = function () {
        var _this = this;
        return Observable_1.Observable.combineLatest(this.formManagementService.loadAll(FormsComponent_1.DE_PREFIX), this.currentLanguageId$)
            .pipe(operators_1.map(function (data) {
            var forms = data[0];
            var languageId = data[1];
            var categoryForms = new Map();
            forms = forms.filter(function (form) { return form.name.getValue(languageId).toLocaleLowerCase().indexOf(_this.searchTerm.toLocaleLowerCase()) !== -1; });
            for (var _i = 0, forms_1 = forms; _i < forms_1.length; _i++) {
                var form = forms_1[_i];
                if (categoryForms.get(form.categorySystemName) != null) {
                    var newForms = categoryForms.get(form.categorySystemName);
                    newForms.push(form);
                    categoryForms.set(form.categorySystemName, newForms);
                }
                else {
                    categoryForms.set(form.categorySystemName, [form]);
                }
            }
            _this.isLoading = false;
            return categoryForms;
        }));
    };
    FormsComponent.prototype.initializeLanguages = function () {
        return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.map(function (language) { return language.getId(); }));
    };
    FormsComponent.DE_PREFIX = "de-service";
    FormsComponent = FormsComponent_1 = __decorate([
        core_1.Component({
            
            selector: 'forms',
            template: require('./forms.component.html'),
            styles: [require('./forms.component.css')]
        }),
        __metadata("design:paramtypes", [form_management_service_1.FormManagementService,
            idm_message_language_service_client_js_1.MessageService,
            idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.LanguageService,
            router_1.Router,
            material_1.MatDialog])
    ], FormsComponent);
    return FormsComponent;
    var FormsComponent_1;
}());
exports.FormsComponent = FormsComponent;
//# sourceMappingURL=forms.component.js.map